import React from 'react';
import { SkipNavLink, SkipNavContent } from '@reach/skip-nav';

import DarkOverlay from '@common/DarkOverlay';
import Header from '@components/demo/header/Header';
import Footer from '@components/demo/footer/Footer';

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <DarkOverlay/>
      <SkipNavLink>{'Skip to Content'}</SkipNavLink>
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </>
  )
}

export default Layout
